import React from 'react';
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import { PartnerMatchCategory } from '@marageti/z4-sdk/lib/travel';
import { ExistingMatchSelection, MatchSelection } from '../../../store/contexts/matching/types';
import { useMatchingStore } from '../../../store';

const PartnerMatchCategoryTitle = {
  [PartnerMatchCategory.NEW]: 'New',
  [PartnerMatchCategory.PRIORITY]: 'Priority Match',
  [PartnerMatchCategory.SECOND_MATCH]: 'Second Match',
  [PartnerMatchCategory.THIRD_MATCH]: 'Third Match',
  [PartnerMatchCategory.LAST_RESORT]: 'Last Resort',
};

const SelectedMatchCards = () => {
  const {
    cooperativeMatch,
    countryCodes,
    onClickMatch,
    existingMatches,
    selectedMatches,
    tripRequest,
  } = useMatchingStore();
  const numberOfSelectedAndExistingMatches = Object.keys(selectedMatches).length || Object.keys(existingMatches).length;
  const numberOfSelectedMatches = Object.keys(selectedMatches).length;
  const tripRequestCountries = tripRequest?.countries;

  return (
    <Box
      sx={{
        padding: 3,
        backgroundColor: '#F0F4FF',
        borderRadius: '12px',
      }}
    >
      <Typography variant="h3">
        {numberOfSelectedMatches > 0 ? `Selected Matches (${numberOfSelectedMatches})` : 'Matches'}
      </Typography>
      {numberOfSelectedAndExistingMatches === 0 ? (
        <Typography color="primary.light" mt={1}>
          Your selected matches will appear here.
        </Typography>
      ) : (
        <Stack spacing={1} mt={1.5}>
          {Object.values(existingMatches).map(({ match, forCountries }: ExistingMatchSelection) => (
            <Card key={match.partner?.id!} sx={{ backgroundColor: 'common.grey', color: 'primary.main' }}>
              <CardHeader
                subheader={(
                  <>
                    <Typography variant="captionItalic" color="primary.light">
                      Previously Matched
                    </Typography>
                    <br />
                    {cooperativeMatch && tripRequestCountries && countryCodes && `Selected for ${forCountries.map((c) => countryCodes[c]).join(', ')}`}
                  </>
                )}
                subheaderTypographyProps={{ color: 'primary.contrastText', variant: 'caption' }}
                title={match.partner?.name}
                titleTypographyProps={{ variant: 'bodyBold' }}
              />
            </Card>
          ))}
          {Object.values(selectedMatches).map(({ match, forCountries }: MatchSelection) => (
            <Card key={match.partner.id} sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText' }}>
              <CardHeader
                action={(
                  <IconButton
                    onClick={() => onClickMatch(match)}
                    sx={(theme) => ({
                      borderRadius: '50%',
                      border: `1px solid ${theme.palette.primary.contrastText}`,
                      backgroundColor: theme.palette.primary.contrastText,
                      height: '25px',
                      width: '25px',
                      '&:hover': {
                        backgroundColor: theme.palette.common.black25,
                        borderColor: theme.palette.common.black25,
                      },
                    })}
                  >
                    <OutlinedIcons.OutlinedCheckIcon sx={{ fontSize: '1.1rem', color: (theme) => (theme.palette.primary.main) }} />
                  </IconButton>
                  )}
                subheader={(
                  <>
                    {cooperativeMatch && tripRequestCountries && countryCodes
                      ? `Selected for ${forCountries.map((c) => countryCodes[c]).join(', ')}`
                      : undefined}
                    {PartnerMatchCategoryTitle[match.matchCategory]}
                  </>
)}
                subheaderTypographyProps={{ color: 'primary.contrastText', variant: 'caption' }}
                title={match.partner.name}
                titleTypographyProps={{ variant: 'bodyBold' }}
              />
            </Card>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default SelectedMatchCards;
